/* PG · new design (product.new-design) — custom elements for the pg-nd-* sections of the live theme.
   Plain script (no modules). Uses the theme's own <product-form> (product-form.js) for the cart. */
(function () {
  'use strict';
  if (window.__pgNdLoaded) return;
  window.__pgNdLoaded = true;

  var MOBILE = window.matchMedia('(max-width: 749px)');

  /* photos at the size they are shown: Shopify CDN images get ?width= from this ladder, picked from the box they
     fill × screen density (capped at 2), so phones no longer download the 2000px originals */
  var PG_WIDTHS = [480, 640, 800, 1000, 1200, 1400, 1600, 2000];
  function fitWidth(box) {
    var w = 0;
    if (box) {
      var cs = getComputedStyle(box);
      w = box.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    }
    if (!(w > 0)) w = window.innerWidth || 1000;
    var need = w * Math.min(window.devicePixelRatio || 1, 2);
    for (var i = 0; i < PG_WIDTHS.length; i++) if (PG_WIDTHS[i] >= need) return PG_WIDTHS[i];
    return PG_WIDTHS[PG_WIDTHS.length - 1];
  }
  function sizedSrc(url, w) {
    if (!url || !/(\/cdn\/shop\/|cdn\.shopify\.com\/)/.test(url) || /\.(gif|svg)(\?|#|$)/i.test(url)) return url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }

  function money(cents) {
    var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var whole = Math.round(cents) / 100;
    var str = whole.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\.00$/, '');
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      try {
        var out = window.Shopify.formatMoney(cents, fmt).replace(/\bUSD\b/g, '').replace(/US\$/g, '$').replace(/\.00(?!\d)/, '').trim();
        if (out) return out;
      } catch (e) {}
    }
    return '$' + str;
  }

  /* Affirm app: re-render the "as low as" message (.affirm-as-low-as) after its data-amount changed (Affirm's documented
     way: update data-amount, then affirm.ui.refresh()). Debounced so quick size clicks end in one refresh; calls refresh
     directly once affirm.js is loaded, and only queues it through affirm.ui.ready() while affirm.js is still loading. */
  var affirmTimer = 0;
  function affirmRefresh() {
    clearTimeout(affirmTimer);
    affirmTimer = setTimeout(function () {
      var a = window.affirm;
      if (!a || !a.ui) return;
      if (typeof a.ui.refresh === 'function') { a.ui.refresh(); return; }
      if (typeof a.ui.ready === 'function') a.ui.ready(function () { var u = window.affirm && window.affirm.ui; if (u && typeof u.refresh === 'function') u.refresh(); });
    }, 250);
  }

  /* gallery loading state (size change → other photos): veil + spinner from pg-nd.css (.pg-nd-gal.is-loading) */
  function galBusy(gal, on) {
    gal.classList.toggle('is-loading', !!on);
    gal.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  /* run cb once img has loaded (or failed, or 6 s passed) */
  function whenImgReady(img, cb) {
    var done = false, timer = 0;
    function fin() { if (done) return; done = true; clearTimeout(timer); cb(); }
    if (!img || (img.complete && img.naturalWidth)) { setTimeout(fin, 0); return; }
    if (img.loading === 'lazy') img.loading = 'eager';
    timer = setTimeout(fin, 6000);
    img.addEventListener('load', fin);
    img.addEventListener('error', fin);
  }

  /* ---------- gallery: scroll-snap slides, arrows, dots (max 5 visible), variant image / variant photos ---------- */
  class PgNdGallery extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('[data-ref="track"]');
      this.dots = this.querySelector('[data-ref="dots"]');
      this.thumbs = this.querySelector('[data-ref="thumbs"]');
      this.mbox = this.querySelector('[data-ref="mbox"]');
      if (!(this.mbox instanceof HTMLDialogElement)) this.mbox = null;
      if (!this.track) return;
      this.track.addEventListener('scroll', function () {
        cancelAnimationFrame(self._raf);
        self._raf = requestAnimationFrame(function () { self.update(); });
      }, { passive: true });
      this.addEventListener('click', function (e) {
        if (self.mbox && self.mbox.contains(e.target)) return;
        var link = e.target.closest('.pg-nd-gal__link');
        if (link && self.mbox && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
          e.preventDefault();
          return self.openViewer(self.slides.indexOf(link.closest('[data-ref="slides"]')));
        }
        var btn = e.target.closest('[data-action]');
        if (!btn || !self.contains(btn)) return;
        var a = btn.dataset.action;
        if (a === 'prev') self.goTo(self.index - 1);
        else if (a === 'next') self.goTo(self.index + 1);
        else if (a === 'goto') self.goTo(Number(btn.dataset.index) || 0);
        else if (a === 'thumb') self.goTo(Number(btn.dataset.index) || 0, 'auto');
        else if (a === 'viewer') self.openViewer(Number(btn.dataset.index) || 0, btn.dataset.tab, Number(btn.dataset.v) || 0);
      });
      /* desktop thumbnails: hovering one shows it (like Amazon) */
      if (this.thumbs) this.thumbs.addEventListener('mouseover', function (e) {
        var t = e.target.closest('[data-action="thumb"]');
        if (t && t.dataset.index !== String(self.index)) self.goTo(Number(t.dataset.index) || 0, 'auto');
      });
      if (this.mbox) {
        this.mbox.addEventListener('click', function (e) {
          if (e.target === self.mbox) return self.mbox.close();
          var b = e.target.closest('[data-mbox]'); if (!b) return;
          var a = b.dataset.mbox;
          if (a === 'close') self.mbox.close();
          else if (a === 'prev') self.step(-1);
          else if (a === 'next') self.step(1);
          else if (a === 'pick') self.pick(b);
          else if (a === 'tab') { var first = self.viewerThumbs().filter(function (t) { return t.dataset.type === b.dataset.tab; })[0]; if (first) self.pick(first); }
        });
        this.mbox.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); self.step(-1); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); self.step(1); }
        });
        this.mbox.addEventListener('close', function () { if (self.mbox.open) return; var st = self.mbox.querySelector('[data-ref="stage"]'); if (st) st.replaceChildren(); self._cur = null; });
      }
      /* listeners outside the element are removed again when a size change swaps the gallery (see PgNdVariants) */
      this._onResize = function () { self.goTo(self.index, 'auto'); };
      window.addEventListener('resize', this._onResize);
      this._section = this.closest('.pg-nd-product');
      this._onVariant = function (e) {
        var v = e.detail && e.detail.variant;
        if (!v || !v.featured_media) return;
        var i = self.slides.findIndex(function (s) { return s.dataset.mediaId === String(v.featured_media.id); });
        if (i >= 0) self.goTo(i);
      };
      if (this._section) this._section.addEventListener('pg-nd:variant', this._onVariant);
      this.update();
    }
    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._section && this._onVariant) this._section.removeEventListener('pg-nd:variant', this._onVariant);
    }
    get slides() { return Array.prototype.slice.call(this.querySelectorAll('[data-ref="slides"]')); }
    get index() { return this.track.clientWidth ? Math.round(this.track.scrollLeft / this.track.clientWidth) : 0; }
    goTo(i, behavior) {
      var n = this.slides.length; if (!n) return;
      var k = ((Number(i) % n) + n) % n;
      this.track.scrollTo({ left: k * this.track.clientWidth, behavior: behavior === 'auto' ? 'auto' : 'smooth' });
      if (behavior === 'auto') this.update(k);
    }
    update(at) {
      var i = at != null ? at : this.index;
      if (this.thumbs) Array.prototype.forEach.call(this.thumbs.querySelectorAll('[data-index]'), function (t) { t.classList.toggle('is-active', Number(t.dataset.index) === i); });
      if (!this.dots) return;
      var buttons = Array.prototype.slice.call(this.dots.children), total = buttons.length;
      if (!total) return;
      var max = Math.min(total, Number(this.dataset.dotsMax) || 5);
      var start = Math.min(Math.max(i - Math.floor(max / 2), 0), total - max);
      var moreLeft = start > 0, moreRight = start + max < total;
      buttons.forEach(function (dot, k) {
        var p = k - start, out = p < 0 || p >= max, size = '';
        if (out) size = 'out';
        else if (k !== i && ((p === 0 && moreLeft) || (p === max - 1 && moreRight))) size = 'sm';
        else if (k !== i && max >= 5 && ((p === 1 && moreLeft) || (p === max - 2 && moreRight))) size = 'md';
        dot.classList.toggle('is-active', k === i);
        dot.classList.toggle('is-sm', size === 'sm');
        dot.classList.toggle('is-md', size === 'md');
        dot.classList.toggle('is-out', size === 'out');
        dot.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
    }
    /* ---- media viewer (Amazon-style popup) ---- */
    viewerThumbs() { return this.mbox ? Array.prototype.slice.call(this.mbox.querySelectorAll('.pg-nd-mbox__th')) : []; }
    openViewer(i, tab, v) {
      if (!this.mbox) return;
      var ths = this.viewerThumbs(), pick = null;
      if (tab === 'video') { var vids = ths.filter(function (t) { return t.dataset.type === 'video'; }); pick = vids[v || 0] || vids[0]; }
      if (!pick) pick = ths.filter(function (t) { return t.dataset.i === String(i); })[0] || ths[0];
      if (!pick) return;
      if (!this.mbox.open) this.mbox.showModal();
      this.pick(pick);
    }
    pick(th) {
      var tab = th.dataset.type === 'video' ? 'video' : 'image', box = this.mbox.querySelector('.pg-nd-mbox');
      if (box) box.dataset.tab = tab;
      Array.prototype.forEach.call(this.mbox.querySelectorAll('[data-mbox="tab"]'), function (b) { var on = b.dataset.tab === tab; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
      this.viewerThumbs().forEach(function (t) { t.hidden = (t.dataset.type === 'video' ? 'video' : 'image') !== tab; t.classList.toggle('is-active', t === th); });
      this._cur = th;
      var stage = this.mbox.querySelector('[data-ref="stage"]'), el;
      if (!stage) return;
      if (th.dataset.yt || th.dataset.vimeo) {
        el = document.createElement('iframe');
        el.src = th.dataset.yt ? 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(th.dataset.yt) + '?autoplay=1&rel=0&playsinline=1' : 'https://player.vimeo.com/video/' + encodeURIComponent(th.dataset.vimeo) + '?autoplay=1';
        el.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen';
        el.allowFullscreen = true; el.title = th.getAttribute('aria-label') || 'Video';
        el.className = 'pg-nd-mbox__video';
      } else if (th.dataset.type === 'video') {
        el = document.createElement('video');
        el.src = th.dataset.src; el.controls = true; el.autoplay = true; el.playsInline = true;
        if (th.dataset.poster) el.poster = th.dataset.poster;
        el.className = 'pg-nd-mbox__video';
      } else {
        el = document.createElement('img');
        el.alt = th.dataset.alt || ''; el.className = 'pg-nd-mbox__img'; el.decoding = 'async';
        el.src = sizedSrc(th.dataset.src, fitWidth(stage)); /* the stage's width, not the 2000px file */
      }
      stage.replaceChildren(el);
      var list = this.viewerThumbs().filter(function (t) { return !t.hidden; });
      Array.prototype.forEach.call(this.mbox.querySelectorAll('.pg-nd-mbox__arrow'), function (b) { b.hidden = list.length < 2; });
      // keep the active thumbnail in view. Desktop: only the thumbnail column scrolls, so move just that column.
      // Phones: photo and thumbnails scroll together (pg-nd.css), so bring the new photo back into view instead.
      var side = th.closest('.pg-nd-mbox__side'), scroller = side && side.parentNode;
      if (side && getComputedStyle(side).overflowY !== 'visible') {
        var tr = th.getBoundingClientRect(), sr = side.getBoundingClientRect();
        if (tr.top < sr.top) side.scrollTop -= sr.top - tr.top + 8;
        else if (tr.bottom > sr.bottom) side.scrollTop += tr.bottom - sr.bottom + 8;
      } else if (scroller && scroller.scrollTop > 0) {
        if (scroller.scrollTo) scroller.scrollTo({ top: 0, behavior: 'smooth' }); else scroller.scrollTop = 0;
      }
      if (tab === 'image' && th.dataset.i != null) this.goTo(Number(th.dataset.i), 'auto');
    }
    step(d) {
      var cur = this._cur; if (!cur) return;
      var list = this.viewerThumbs().filter(function (t) { return !t.hidden; }), k = list.indexOf(cur);
      if (k < 0 || list.length < 2) return;
      this.pick(list[(k + d + list.length) % list.length]);
    }
  }

  /* ---------- variants: size cards → re-render the section for the chosen variant (price, messages, button, gallery) ---------- */
  class PgNdVariants extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.addEventListener('change', function (e) {
        if (e.target && e.target.matches('input[type="radio"]')) self.onChange();
      });
    }
    get galSigs() {
      if (this._galSigs) return this._galSigs;
      var el = this.querySelector('[data-ref="gal-sigs"]');
      try { this._galSigs = el ? JSON.parse(el.textContent) : {}; } catch (err) { this._galSigs = {}; }
      return this._galSigs;
    }
    get variants() {
      if (this._variants) return this._variants;
      var el = this.querySelector('[data-ref="variants"]');
      try { this._variants = JSON.parse(el.textContent); } catch (err) { this._variants = []; }
      return this._variants;
    }
    get selectedOptions() {
      return Array.prototype.slice.call(this.querySelectorAll('fieldset')).map(function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    get currentVariant() {
      var opts = this.selectedOptions;
      return this.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }
    onChange() {
      var v = this.currentVariant, root = this.closest('.pg-nd-product');
      var sid = this.dataset.section, url = this.dataset.url;
      if (!root) return;
      if (!v) { this.setUnavailable(root); return; }
      var idInput = root.querySelector('#product-form-' + sid + ' input[name="id"]');
      if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
      root.dispatchEvent(new CustomEvent('pg-nd:variant', { detail: { variant: v } }));
      var self = this;
      /* gallery loader: only when the chosen size brings another set of photos (see the gal-sigs JSON) */
      var gal0 = root.querySelector('pg-nd-gallery'), sig = this.galSigs[v.id];
      if (gal0) galBusy(gal0, !!sig && sig !== gal0.getAttribute('data-pg-gal-sig'));
      root.classList.add('is-updating');
      fetch(url + '?variant=' + v.id + '&section_id=' + sid)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (self.currentVariant !== v) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          /* gallery: the chosen size's own photos (variant metafield custom.additional_images, else the product media).
             The new section has them; swap the gallery only when the set of images changed (data-pg-gal). */
          var gal = root.querySelector('pg-nd-gallery'), nextGal = doc.querySelector('pg-nd-gallery');
          if (gal && nextGal && gal.getAttribute('data-pg-gal') !== nextGal.getAttribute('data-pg-gal')) {
            /* keep the current photos under the loader until the first new photo has loaded, then swap (the new one fades in) */
            var fresh = document.importNode(nextGal, true);
            galBusy(gal, true);
            whenImgReady(fresh.querySelector('[data-ref="slides"] img'), function () {
              if (self.currentVariant !== v || !gal.isConnected) return;
              if (gal.mbox && gal.mbox.open) gal.mbox.close();
              fresh.classList.add('is-fresh');
              gal.replaceWith(fresh);
              setTimeout(function () { fresh.classList.remove('is-fresh'); }, 400);
            });
          } else if (gal) galBusy(gal, false);
          var oldAla = root.querySelector('[data-pg-sync="price"] .affirm-as-low-as');
          root.querySelectorAll('[data-pg-sync]').forEach(function (el) {
            var next = doc.querySelector('[data-pg-sync="' + el.dataset.pgSync + '"]');
            if (next) el.replaceWith(document.importNode(next, true));
          });
          /* keep the Affirm element Affirm already rendered: give it the new amount and let Affirm re-render it in place */
          var newAla = root.querySelector('[data-pg-sync="price"] .affirm-as-low-as');
          if (oldAla && newAla) {
            var changed = oldAla.getAttribute('data-amount') !== newAla.getAttribute('data-amount');
            Array.prototype.forEach.call(newAla.attributes, function (at) { if (at.name.indexOf('data-') === 0) oldAla.setAttribute(at.name, at.value); });
            newAla.replaceWith(oldAla);
            if (changed) affirmRefresh();
          } else if (newAla) affirmRefresh();
          var stickyPrice = root.querySelector('[data-pg-sync="sticky-price"]');
          if (stickyPrice && !stickyPrice.textContent.trim()) stickyPrice.textContent = money(v.price);
        })
        .catch(function () { var g = root.querySelector('pg-nd-gallery'); if (g && self.currentVariant === v) galBusy(g, false); })
        .finally(function () { root.classList.remove('is-updating'); });
    }
    setUnavailable(root) {
      var btn = root.querySelector('.pg-nd-atc'); if (btn) { btn.disabled = true; var s = btn.querySelector('span'); if (s) s.textContent = (window.variantStrings && window.variantStrings.unavailable) || 'Unavailable'; }
      var sb = root.querySelector('.pg-nd-sticky__btn'); if (sb) sb.disabled = true;
    }
  }

  /* ---------- sticky buy bar ---------- */
  class PgNdSticky extends HTMLElement {
    connectedCallback() {
      var self = this;
      var root = this.closest('.pg-nd-product');
      var anchor = root && root.querySelector('[data-pg-sticky-anchor]');
      var apply = function () {
        if (self._io) { self._io.disconnect(); self._io = null; }
        if (self.dataset.mobile === 'always' && MOBILE.matches) { self.show(true); return; }
        if (!anchor) return self.show(false);
        var header = document.querySelector('.shopify-section-header, sticky-header, .header-wrapper');
        var top = header ? Math.round(header.getBoundingClientRect().height) : 0;
        self._io = new IntersectionObserver(function (entries) {
          var entry = entries[0]; if (!entry) return;
          self.show(!entry.isIntersecting && entry.boundingClientRect.top < top);
        }, { threshold: 0, rootMargin: '-' + top + 'px 0px 0px 0px' });
        self._io.observe(anchor);
      };
      apply();
      MOBILE.addEventListener('change', apply);
      var t = 0; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 200); });
    }
    show(on) {
      this.classList.toggle('is-on', on);
      this.toggleAttribute('inert', !on);
      this.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.documentElement.style.setProperty('--pg-nd-sticky-h', on ? this.offsetHeight + 'px' : '0px');
    }
  }

  /* ---------- quantity ---------- */
  class PgNdQty extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-action]'); if (!b) return;
        var input = self.querySelector('[data-ref="input"]'); if (!input) return;
        var min = Number(input.min) || 1, max = input.max ? Number(input.max) : Infinity;
        var next = (Number(input.value) || min) + (b.dataset.action === 'plus' ? 1 : -1);
        input.value = String(Math.min(max, Math.max(min, next)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  /* ---------- dialogs (contact / guide): opened by links to #pg-contact / #pg-guide ---------- */
  class PgNdDialog extends HTMLElement {
    connectedCallback() {
      var self = this, dlg = this.querySelector('[data-ref="dlg"]');
      if (!(dlg instanceof HTMLDialogElement)) return;
      dlg.addEventListener('click', function (e) { if (e.target === dlg) self.close(); });
      this.addEventListener('click', function (e) { if (e.target.closest('[data-action="close"]')) self.close(); });
      dlg.addEventListener('close', function () {
        if (!location.hash && location.search.indexOf('contact_posted') < 0) return;
        try { var u = new URL(location.href); u.searchParams.delete('contact_posted'); u.hash = ''; history.replaceState({}, '', u.toString()); } catch (e) {}
      });
      var id = this.dataset.formId;
      if (id && location.hash === '#' + id) this.open();
      else { var st = this.querySelector('[data-pg-state]'); if (st) st.removeAttribute('data-pg-state'); }
    }
    open() { var d = this.querySelector('[data-ref="dlg"]'); if (d && !d.open) d.showModal(); }
    close() { var d = this.querySelector('[data-ref="dlg"]'); if (d && d.open) d.close(); }
  }
  document.addEventListener('click', function (e) {
    var link = e.target instanceof Element ? e.target.closest('a[href*="#pg-contact"], a[href*="#pg-guide"]') : null;
    if (!link || e.metaKey || e.ctrlKey) return;
    var id = link.getAttribute('href').indexOf('#pg-guide') >= 0 ? 'pg-guide-dialog' : 'pg-contact-dialog';
    var dialog = document.getElementById(id);
    if (dialog && typeof dialog.open === 'function') { e.preventDefault(); dialog.open(); }
  });

  /* ---------- accordion row (details) + collapse (benefit cards on mobile) ---------- */
  class PgNdAccordion extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._frames = new Map();
      this.addEventListener('click', function (e) {
        var yt = e.target.closest('a[data-pg-yt]');
        if (yt && self.contains(yt) && !e.metaKey && !e.ctrlKey) {
          e.preventDefault();
          var f = document.createElement('iframe');
          f.className = 'pg-nd-vid__frame';
          f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(yt.dataset.pgYt) + '?autoplay=1&rel=0&playsinline=1';
          f.title = yt.getAttribute('aria-label') || 'Video';
          f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          f.allowFullscreen = true;
          self._frames.set(f, yt);
          yt.replaceWith(f);
          return;
        }
        if (e.target.closest('[data-action="toggle"]')) self.toggle();
      });
    }
    toggle() {
      var open = !this.hasAttribute('open');
      this.toggleAttribute('open', open);
      var b = this.querySelector('[aria-expanded]'); if (b) b.setAttribute('aria-expanded', String(open));
      if (!open) { this._frames.forEach(function (link, frame) { frame.replaceWith(link); }); this._frames.clear(); }
    }
  }
  class PgNdCollapse extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.addEventListener('click', function (e) { if (e.target.closest('[data-action="toggle"]')) self.toggle(); });
    }
    toggle() {
      var open = !this.hasAttribute('open');
      this.toggleAttribute('open', open);
      var b = this.querySelector('[aria-expanded]'); if (b) b.setAttribute('aria-expanded', String(open));
    }
  }

  /* ---------- carousel (reviews, related): scroll track, arrows, dots, drag, optional feed ---------- */
  class PgNdCarousel extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('[data-ref="track"]');
      this.dots = this.querySelector('[data-ref="dots"]');
      if (!this.track) return;
      this.track.addEventListener('scroll', function () { cancelAnimationFrame(self._raf); self._raf = requestAnimationFrame(function () { self.update(); }); }, { passive: true });
      window.addEventListener('resize', function () { self.update(); });
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-action], [data-pg-page]'); if (!b || !self.contains(b)) return;
        if (b.dataset.pgPage != null) return self.goTo(Number(b.dataset.pgPage));
        if (b.dataset.action === 'prev') self.prev(); else if (b.dataset.action === 'next') self.next();
      });
      /* drag with the mouse */
      var drag = null;
      this.track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0 || self.track.scrollWidth - self.track.clientWidth <= 2) return;
        drag = { id: e.pointerId, x: e.clientX, left: self.track.scrollLeft, moved: false };
      });
      this.track.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x;
        if (!drag.moved) { if (Math.abs(dx) < 6) return; drag.moved = true; try { self.track.setPointerCapture(drag.id); } catch (err) {} self.track.classList.add('is-dragging'); }
        self.track.scrollLeft = drag.left - dx;
      });
      var up = function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var moved = drag.moved; drag = null;
        if (!moved) return;
        self._dragged = true; setTimeout(function () { self._dragged = false; }, 60);
        self.track.classList.remove('is-dragging');
      };
      this.track.addEventListener('pointerup', up); this.track.addEventListener('pointercancel', up);
      this.track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      this.track.addEventListener('click', function (e) { if (self._dragged) { e.preventDefault(); e.stopPropagation(); } }, true);
      /* story popup: a click on a review card opens the story in <pg-nd-story> instead of the story page */
      if (this.dataset.storyPopup != null) {
        this.track.addEventListener('click', function (e) {
          var card = e.target.closest('.pg-nd-rev__card');
          if (!card || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          var story = (self.closest('.pg-nd-revb') || document).querySelector('pg-nd-story');
          if (!story || typeof story.openFor !== 'function') return;
          e.preventDefault();
          var cards = self.items.filter(function (el) { return el.matches('.pg-nd-rev__card'); });
          story.openFor(cards.map(function (el) { return el.getAttribute('href'); }), Math.max(0, cards.indexOf(card)));
        });
      }
      this.update();
      this.loadFeed();
    }
    get items() { return Array.prototype.slice.call(this.track.children); }
    get step() { var v = Number(MOBILE.matches ? this.dataset.stepMobile : this.dataset.step); return v || this.track.clientWidth; }
    get pageOffsets() {
      var t = this.track, max = Math.max(0, t.scrollWidth - t.clientWidth);
      if (max <= 2) return [0];
      var pad = parseFloat(getComputedStyle(t).scrollPaddingLeft) || 0;
      var base = t.getBoundingClientRect().left - t.scrollLeft + pad, offsets = [];
      this.items.forEach(function (item) {
        var left = Math.max(0, Math.round(item.getBoundingClientRect().left - base));
        if (left > max - 8) return;
        if (!offsets.length || left - offsets[offsets.length - 1] > 8) offsets.push(left);
      });
      offsets.push(max);
      return offsets;
    }
    get currentPage() {
      var left = this.track.scrollLeft, best = 0, bestDist = Infinity;
      this.pageOffsets.forEach(function (o, k) { var d = Math.abs(o - left); if (d < bestDist) { bestDist = d; best = k; } });
      return best;
    }
    prev() { if (Number(this.dataset.step)) this.track.scrollBy({ left: -this.step, behavior: 'smooth' }); else this.goTo(this.currentPage - 1); }
    next() { if (Number(this.dataset.step)) this.track.scrollBy({ left: this.step, behavior: 'smooth' }); else this.goTo(this.currentPage + 1); }
    goTo(i) { var o = this.pageOffsets, k = Math.min(Math.max(Number(i) || 0, 0), o.length - 1); this.track.scrollTo({ left: o[k], behavior: 'smooth' }); }
    update() {
      var t = this.track, max = t.scrollWidth - t.clientWidth, fits = max <= 2;
      this.classList.toggle('is-static', fits);
      this.querySelectorAll('[data-action="prev"], [data-action="next"]').forEach(function (btn) {
        btn.style.display = fits ? 'none' : '';
        btn.disabled = !fits && (btn.dataset.action === 'prev' ? t.scrollLeft <= 2 : t.scrollLeft >= max - 2);
      });
      if (!this.dots) return;
      this.dots.style.display = fits ? 'none' : '';
      var total = fits ? 0 : this.pageOffsets.length;
      if (this.dots.children.length !== total) {
        this.dots.replaceChildren.apply(this.dots, Array.apply(null, { length: total }).map(function (_, k) {
          var d = document.createElement('button'); d.type = 'button'; d.className = 'pg-nd-dot'; d.dataset.pgPage = String(k); d.setAttribute('aria-label', (k + 1) + ' / ' + total); return d;
        }));
      }
      if (!total) return;
      var i = this.currentPage, shown = Math.min(total, 5), start = Math.min(Math.max(i - Math.floor(shown / 2), 0), total - shown);
      var moreLeft = start > 0, moreRight = start + shown < total;
      Array.prototype.forEach.call(this.dots.children, function (dot, k) {
        var p = k - start, out = p < 0 || p >= shown, size = '';
        if (out) size = 'out'; else if (k !== i && ((p === 0 && moreLeft) || (p === shown - 1 && moreRight))) size = 'sm'; else if (k !== i && shown >= 5 && ((p === 1 && moreLeft) || (p === shown - 2 && moreRight))) size = 'md';
        dot.classList.toggle('is-active', k === i); dot.classList.toggle('is-sm', size === 'sm'); dot.classList.toggle('is-md', size === 'md'); dot.classList.toggle('is-out', size === 'out');
      });
    }
    loadFeed() {
      var self = this, url = this.dataset.feed; if (!url) return;
      var limit = Number(this.dataset.limit) || 10;
      var append = function (feedUrl) {
        return fetch(feedUrl).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var seen = {}; self.items.forEach(function (el) { seen[el.dataset.pgCard] = true; });
          var added = 0;
          Array.prototype.forEach.call(doc.querySelectorAll('[data-pg-card]'), function (card) {
            if (self.items.length >= limit) return;
            var key = card.getAttribute('data-pg-card');
            if (seen[key]) return; seen[key] = true;
            self.track.appendChild(document.importNode(card, true)); added++;
          });
          return added;
        }).catch(function () { return 0; });
      };
      append(url).then(function (n) {
        if (n > 0 || !self.dataset.feedFallback) return;
        var fallbacks = self.dataset.feedFallback.split(' ').filter(Boolean);
        return fallbacks.reduce(function (p, fb) { return p.then(function (done) { return done ? true : append(fb).then(function (k) { return k > 0; }); }); }, Promise.resolve(false));
      }).finally(function () {
        self.classList.remove('is-loading');
        self.classList.toggle('is-empty', self.items.length === 0);
        self.update();
      });
    }
  }

  /* ---------- story popup (owner reviews) ---------- */
  class PgNdStory extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.dlg = this.querySelector('[data-ref="dlg"]');
      if (!(this.dlg instanceof HTMLDialogElement)) return;
      this.cache = {}; this.urls = []; this.index = 0;
      this.dlg.addEventListener('click', function (e) {
        if (e.target === self.dlg) return self.close();
        var b = e.target.closest('[data-action]');
        if (b && self.dlg.contains(b)) {
          var a = b.dataset.action;
          if (a === 'close') self.close();
          else if (a === 'prev') self.show(self.index - 1);
          else if (a === 'next') self.show(self.index + 1);
          else if (a === 'photo-close') self.photo(null);
          return;
        }
        var ph = e.target.closest('[data-pg-photo]');
        if (ph && !e.metaKey && !e.ctrlKey) { e.preventDefault(); return self.photo(ph); }
        if (e.target === self.ref('photo')) self.photo(null);
      });
      this.dlg.addEventListener('cancel', function (e) { var ph = self.ref('photo'); if (ph && !ph.hidden) { e.preventDefault(); self.photo(null); } });
      this.dlg.addEventListener('keydown', function (e) {
        if (self.urls.length < 2 || (e.target.closest && e.target.closest('input, textarea, select'))) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.show(self.index - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); self.show(self.index + 1); }
      });
      this.dlg.addEventListener('close', function () { self.photo(null); });
    }
    ref(name) { return this.querySelector('[data-ref="' + name + '"]'); }
    openFor(urls, i) {
      this.urls = (urls || []).filter(Boolean);
      if (!this.urls.length || !this.dlg) return;
      var multi = this.urls.length > 1;
      this.querySelectorAll('[data-action="prev"], [data-action="next"]').forEach(function (b) { b.hidden = !multi; });
      this.show(i || 0);
      if (!this.dlg.open) this.dlg.showModal();
    }
    show(i) {
      var n = this.urls.length; if (!n) return;
      var self = this, k = ((i % n) + n) % n, url = this.urls[k], token = {};
      this.index = k; this._token = token;
      this.photo(null);
      var count = this.ref('count'); if (count) count.textContent = n > 1 ? (k + 1) + ' / ' + n : '';
      var page = this.ref('page'); if (page) page.href = url;
      this.classList.add('is-loading');
      this.load(url).then(function (html) {
        if (self._token !== token) return;
        self.ref('body').innerHTML = html;
        self.ref('scroll').scrollTop = 0;
      }, function () {
        if (self._token === token) location.href = url;
      }).then(function () { if (self._token === token) self.classList.remove('is-loading'); });
      if (n > 1) this.load(this.urls[(k + 1) % n]).catch(function () {});
    }
    load(url) {
      var self = this;
      if (!this.cache[url]) {
        var u = new URL(url, location.origin); u.searchParams.set('view', this.dataset.view || 'pg-nd-story');
        this.cache[url] = fetch(u.toString()).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
          var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pg-story-body]');
          if (!el) throw new Error('no story');
          return el.outerHTML;
        });
        this.cache[url].catch(function () { delete self.cache[url]; });
      }
      return this.cache[url];
    }
    photo(link) {
      var box = this.ref('photo'), img = this.ref('photo-img'); if (!box || !img) return;
      if (!link) { box.hidden = true; img.removeAttribute('src'); return; }
      var t = link.querySelector('img');
      img.alt = t ? t.alt : '';
      box.hidden = false;
      img.src = sizedSrc(link.getAttribute('href'), fitWidth(box)); /* the viewer's width, not the original file */
    }
    close() { if (this.dlg && this.dlg.open) this.dlg.close(); }
  }

  var defs = { 'pg-nd-gallery': PgNdGallery, 'pg-nd-variants': PgNdVariants, 'pg-nd-sticky': PgNdSticky, 'pg-nd-qty': PgNdQty, 'pg-nd-dialog': PgNdDialog, 'pg-nd-accordion': PgNdAccordion, 'pg-nd-collapse': PgNdCollapse, 'pg-nd-carousel': PgNdCarousel, 'pg-nd-story': PgNdStory };
  Object.keys(defs).forEach(function (name) { if (!customElements.get(name)) customElements.define(name, defs[name]); });
  if (document.querySelector('.pg-nd .affirm-as-low-as')) affirmRefresh();
})();
